import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {AuthRepository} from './repositories/auth.repository';
import {AuthService} from './services/auth.service';

@NgModule({
  imports: [
    CommonModule,
  ],
  declarations: [

  ],
  providers: [
    AuthService,
    AuthRepository,
  ],
  exports: [

  ],
})
export class AuthModule { }



// WEBPACK FOOTER //
// /usr/src/app/src/app/shared/auth/auth.module.ts